import { styled } from '@thg-commerce/enterprise-pages/src/Product/theme'
import { spacing, Text } from '@thg-commerce/gravity-theme'

export const Container = styled.div`
  margin-top: ${spacing(1)};
  background-color: #dfdfdf;
  padding: ${spacing(2)};
  border-radius: 8px;
`

export const CountdownTitle = styled.div`
  ${Text('medium1', 'alternate')}
  margin: ${(props) =>
    spacing(
      props.theme.pageTheme.nextDayDeliveryCountdown?.title?.margin?.bottom ||
        1,
    )} 0;

  ${(props) =>
    props.theme.pageTheme.nextDayDeliveryCountdown?.title?.transform &&
    `text-transform: ${props.theme.pageTheme.nextDayDeliveryCountdown?.title?.transform};`}
`

export const TimeToCountdownText = styled.div`
  ${Text('large1', 'alternate')}
  margin: 0 ${spacing(0.5)};
  color: #000000;

  &:first-child {
    margin-left: 0;
  }
`

export const TimeToCountdownContainer = styled.div`
  ${Text('bodyText', 'alternate')}
  display: flex;
  align-items: baseline;
`

export const CutOffTime = styled.b`
  ${Text('large1', 'alternate')}
  color: #000000;
`
